import { ReactNode, useMemo } from 'react';
import { alpha, ThemeProvider, createTheme, useTheme, ThemeOptions } from '@mui/material/styles';
import useSettings from '../../hooks/useSettings';
import componentsOverride from '../../theme/overrides';

type Props = {
  children: ReactNode;
};

export default function ThemeColorPresets({ children }: Props) {
  const defaultTheme = useTheme();
  const { setColor } = useSettings();

  const theme = useMemo(() => {
    const themeOptions: ThemeOptions = {
      palette: {
        ...defaultTheme.palette,
        primary: setColor,
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(setColor.main, 0.24)}`,
      },
    };
    const newTheme = createTheme({ ...defaultTheme, ...themeOptions });
    newTheme.components = componentsOverride(newTheme);
    return newTheme;
  }, [setColor, defaultTheme]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
